module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "story-1-danti-duck-loses-her-quack"
    }
  }, [_c('h1', [_vm._v("Story 1"), _c('br'), _vm._v(" Danti Duck Loses Her Quack")]), _vm._v(" "), _c('p', {
    staticClass: "mm",
    staticStyle: {
      "text-align": "center",
      "margin-top": "25px",
      "margin-bottom": "25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.42708in",
      "height": "5.52014in"
    },
    attrs: {
      "alt": "",
      "src": "media/file2.png"
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_c('em', [_vm._v("Danti"), _c('br')])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2cea7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch007.vue
// module id = 81
// module chunks = 0